var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94901 5.33333C5.47643 5.33333 5.992 5.17694 6.43053 4.88392C6.86906 4.5909 7.21086 4.17443 7.41269 3.68716C7.61452 3.19989 7.66733 2.66371 7.56444 2.14643C7.46154 1.62914 7.20757 1.15399 6.83463 0.78105C6.46169 0.40811 5.98653 0.154134 5.46925 0.0512405C4.95197 -0.0516535 4.41579 0.00115541 3.92852 0.202989C3.44125 0.404823 3.02478 0.746616 2.73176 1.18515C2.43874 1.62368 2.28234 2.13925 2.28234 2.66667C2.28234 3.37391 2.5633 4.05219 3.06339 4.55229C3.56349 5.05238 4.24177 5.33333 4.94901 5.33333ZM4.94905 6.33334C3.7542 6.33341 2.59885 6.76127 1.69216 7.53946C0.78546 8.31765 0.187337 9.39474 0.00605699 10.5758C-0.00678159 10.6704 0.000843629 10.7668 0.0284178 10.8583C0.055992 10.9497 0.102873 11.0342 0.165896 11.106C0.228918 11.1778 0.306615 11.2353 0.39374 11.2745C0.480864 11.3137 0.575389 11.3338 0.67093 11.3333H9.22721C9.32275 11.3338 9.41727 11.3137 9.50439 11.2745C9.59152 11.2353 9.66921 11.1778 9.73223 11.106C9.79525 11.0342 9.84213 10.9497 9.8697 10.8582C9.89727 10.7668 9.90489 10.6704 9.89205 10.5758C9.71076 9.39474 9.11264 8.31765 8.20595 7.53946C7.29925 6.76127 6.14391 6.33341 4.94905 6.33334Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.913d8cd32eb2298f8306b2982255e4a9.svg";
export { ForwardRef as ReactComponent };